import { firebaseConfig } from '../../private';
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";

// Initialize Firebase once
const app = initializeApp(firebaseConfig);

// Export the specific service instances
export const db = getFirestore(app);
export const rtdb = getDatabase(app);
export const auth = getAuth(app);